import { Component, Input, OnInit } from '@angular/core';
import { FinancialDashboardGroup } from '../../models/financial-dashboard-config.model';
import { ExaminerFinancialsComponent } from '../examiner-financials/examiner-financials.component';


@Component({
  selector: 'app-examiner-pass-rates',
  template: `
    <div (click)="navToReports()">
        <app-financial-dashboard *ngIf="financialDashboardConfig" [financialDashboardConfig]="financialDashboardConfig"
       [customFilters]="customFilters"
       [hidePageContent]="hidePageContent"
       [hidePills]="hidePills"
       [hideFilters]="hideFilters"
       [hideChartDisplayPreferenceToggle]="true"
       
       (currentGroupChanged)="setGroup($event)"></app-financial-dashboard>
    </div>
  `
})
export class ExaminerPassRatesComponent extends ExaminerFinancialsComponent {
  
  @Input() hidePageContent: boolean = true;
  @Input() hidePills: boolean = true;
  @Input() hideFilters: boolean = true;

  @Input() contentConfigKey: string = 'examiner-pass-rates';

  ngOnInit(): void {
    super.ngOnInit();

  }

  navToReports() {
    this.dwRoutingService.navigateToUrl('/reports');
  }

  setupDashboard() {
     this.financialDashboardConfig = {
      contentConfigKey: 'examiner-financials',
      staticFilter: {
        pilotExaminerId: this.examiner?.PilotExaminerId || -1,
      },
      groups: [
        this.buildCheckrideStatGroup(),
      ]
    }
  }

  protected buildCheckrideStatGroup(): FinancialDashboardGroup {
    const group = super.buildCheckrideStatGroup();

    group.charts = [];

    return group;
  }

}


